import { useState } from "react";
import FlexRow from "../../../../../components/base/FlexRow";
import Icon from "../../../../../components/base/Icon";
import IconButton from "../../../../../components/base/IconButton";
import Job from "../../models/Job";
import { getUser, hasRole, openEditJobAddress, openSendJob, useHub } from "../../../../../core/Global";
import Map from "../../../../../components/here/Map";

interface IProps {
    job: Job
    mapLink?: string
}
export default function JobDrawerAddress(props: IProps) {

    const user = getUser()


    return (
        <div>
            <FlexRow className="px-10">
                <div>
                    <div className="text-muted fs-8">
                        <Icon icon="location-dot" size={10} className="me-2" type="solid" />
                        Address
                    </div>
                    <div className="ps-5">
                        {
                            user?.isTech ?
                                <a href={props.mapLink} target="_blank">
                                    {props.job.address?.title}
                                </a>
                                : <>{props.job.address?.title}</>
                        }

                    </div>
                </div>
                {
                    !user?.isTech &&
                    <FlexRow className="flex-grow-1" justify="end">
                        {
                            (!props.job.isArchived || hasRole("EditArchivedJobs")) &&
                            <IconButton icon="edit" size={14} type="solid" title="Edit Address"
                                onClick={e => {
                                    openEditJobAddress(props.job)
                                }} />
                        }
                    </FlexRow>
                }

            </FlexRow>

            {
                user?.isTech && props.job.address?.position && !props.job.isClosed && !props.job.isCanceled &&
                <div className="mt-5 no-touch">
                    <Map id="map-job-for-tech"
                        center={props.job.address.position}
                        jobMarker={props.job.address.position}
                        height={200} zoom={15} />
                </div>
            }

        </div>
    )
}